import { mapState } from "vuex";
import Tinymce from "@/components/tinymce";

let self = {};

export default {
  components: {
    Tinymce,
  },
  data() {
    return {
      TinymceMain: "",
      contentInit: {},
      activityId: "",
      origin: process.env,

      content: null,
      area: {
        lazy: true,
        lazyLoad(node, resolve) {
          const { level, value = 0 } = node;
          setTimeout(() => {
            self.$store
              .dispatch("app/getAreas", {
                parentId: value,
              })
              .then((data) => {
                const nodes = [];
                data.forEach(function (item) {
                  if (item.end) {
                    const map = {
                      value: String(item.id),
                      label: String(item.name),
                      leaf: level >= 2,
                    };
                    nodes.push(map);
                  } else {
                    const map = {
                      value: String(item.id),
                      label: String(item.name),
                      leaf: level >= 3,
                    };
                    nodes.push(map);
                  }
                });
                // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                resolve(nodes);
              });
          }, 1000);
        },
      },
      areaValue: [],
      date: [],
      goodsPriceList: [], // 阶梯设置的list
      goodPriceVisible: false,
      priceIndex: 0,
      activity: {
        id: "",
        name: "",
        startTime: "",
        endTime: "",
        // shippingArea: "",
        detailAddress: "",
        priceType: 1,
        ruleDesc: "",
        goodsInfoList: [],
        depositRatio: "",
        paymentTimeLimit: "",
        thresholdLimit: 0,
      },
      rules: {
        name: [{ required: true, message: "请输入拼单名称", trigger: "blur" }],
        depositRatio: [{ required: true, message: "请输入定金比例", trigger: "blur" }],
        paymentTimeLimit: [{ required: true, message: "请选择订单支付时间", trigger: "change" }],
      },
      error: {
        date: "",
        addr: "",
      },
      paymentTimeList: [
        {
          id: "24",
          name: "24小时",
        },
        {
          id: "48",
          name: "48小时",
        },
        {
          id: "72",
          name: "72小时",
        },
      ],
      chooseGoodVisible: false,
      searchName: "",

      pageSize: 10, // 商品列表页分页大小
      currentPage: 1, // 商品列表页当前分页
      totalCount: 0, // 商品列表页商品总数
      goodsDataList: [], // 店铺商品列表
      goodsSelectList: [], // 店铺商品选中列表
      checkGoodsList: [], // 选择的商品
      searchGoods: {
        name: "",
        axis: "",
        pageNum: 1,
        pageSize: 10,
        isoa: 0,
        status: "5",
        isGroup: 1,
        isVip: 0,
      },
      // 禁用选择当前时间之前
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },

      isEdit: false,
      timeout: setTimeout(() => ({}), 500),
    };
  },
  computed: mapState({
    isReload: (state) => state.app.isReload,
    userInfo: (state) => state.app.userInfo,
  }),
  created() {
    if (this.isReload) {
      window.location.reload();
      this.$store.commit("app/setIsReload", false);
    }
    const { id, isEnd } = this.$route.query;
    this.activityId = id || "";
    this.activity.id = id || "";
    this.isEnd = isEnd || "";

    this.listShopGoods(); // 获取商品
    if (id) {
      this.getDetail();
    } else {
      this.getShop();
    }
  },
  // 进入页面加载数据 -相当于jquery的ready
  mounted() {
    self = this;
  },
  // 监听器
  filters: {},
  methods: {
    // 查询当前默认店铺
    getShop() {
      this.$store.dispatch("orderHome/index/getQuerySingleShop").then((res) => {
        if (res.data) {
          console.log("查询当前默认店铺", res.data);
          const { addr, areaName } = res.data;
          // this.areaValue = areaAxis.replace("$", "").split("$");
          this.activity.detailAddress = `${areaName}${addr}`;
        }
      });
    },
    // 点击添加货品
    selectGoodsList() {
      const { goodsSelectList, goodsDataList } = this;
      this.chooseGoodVisible = true;
      this.goodsSelectList = this.checkGoodsList.concat();
      this.$nextTick(() => {
        goodsDataList.forEach((row) => {
          if (goodsSelectList.some((item2) => row.goodsId === item2.goodsId)) {
            this.$refs.multipleTable.toggleRowSelection(row, true);
          }
        });
      });
    },
    // 查询活动商品
    listShopGoods() {
      const { searchName, activityId } = this;
      this.$store
        .dispatch("groupBuying/getPromotionGoods", {
          status: 5,
          name: searchName,
          combinationOrderId: activityId,
        })
        .then((res) => {
          console.log("活动商品", res);
          const goodsList = res.goodsList || [];
          this.goodsDataList = goodsList.map((item) => {
            return {
              ...item,
              maxQuantity: "",
              singlePrice: "",
              startQuantity: "",
              unit: item.spec.split("/")[1],
            };
          });
        });
    },
    goodSearch() {
      this.listShopGoods();
    },

    // 确定选择商品
    goodsDialogConfirm() {
      // this.checkGoodsList = this.goodsSelectList.concat();
      const goodList = [];
      this.goodsSelectList.forEach((item) => {
        if (this.checkGoodsList.some((item2) => item.goodsId === String(item2.goodsId))) {
          this.checkGoodsList.forEach((item1) => {
            if (item.goodsId === String(item1.goodsId)) {
              goodList.push(item1);
            }
          });
        } else {
          goodList.push(item);
        }
      });
      if (this.activity.thresholdLimit === 1 && goodList.length > 1) {
        this.$message.warning("当前拼单成功门槛仅支持添加一个商品，请重新选择");
        return;
      }
      this.checkGoodsList = goodList;
      this.goodsDialogCancel();
    },

    goodsDialogCancel() {
      this.chooseGoodVisible = false;
      this.$refs.multipleTable.clearSelection();
    },
    // 删除已选中商品
    removeCheckGoods(index) {
      this.checkGoodsList.splice(index, 1);
    },

    handleSelectionChange(selection) {
      this.goodsSelectList = selection;
    },

    // num 输入的数字 decimal 小数 true false
    formatNums(nums, decimal) {
      let value = `${nums}`;
      value = value.replace(/[^\d.]/g, "");
      value = value.replace(/\.{2,}/g, ".");
      value = value.replace(".", "$#$");
      value = value.replace(/\./g, "");
      value = value.replace("$#$", ".");
      const reg = new RegExp("^(-)?(\\d{1,8})\\.(\\d{0,6}).*$");
      value = value.replace(reg, "$1$2.$3");
      console.info(value);
      if (value.indexOf(".") < 0 && value !== "" && value !== "-") {
        // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        value = parseFloat(value);
      }
      if (value && !decimal) {
        value = parseInt(value, 10);
      }
      if (value === 0) {
        return "";
      }
      return value;
    },
    // 保存
    onSubmit() {
      const { activity, checkGoodsList } = this;
      // 校验参数
      // 商品
      if (!activity.startTime || !activity.endTime) {
        this.error.date = "请选择时间";
        return;
      }
      if (new Date(activity.startTime) >= new Date(activity.endTime)) {
        this.error.date = "结束时间不得小于开始时间";
        return;
      }
      this.error.date = "";
      if (new Date() >= new Date(activity.endTime)) {
        this.$message.warning("结束时间不得小于当前时间");
        return;
      }
      // !activity.shippingArea ||
      if (!activity.detailAddress) {
        this.error.addr = "请填写发货地";
        return;
      }
      this.error.addr = "";
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (activity.thresholdLimit === 1 && checkGoodsList.length > 1) {
            this.$message.warning("当前拼单成功门槛仅支持添加一个商品，请重新选择");
            return;
          }
          if (!checkGoodsList.length) {
            this.$message.warning("请选择商品");
            return;
          }
          if (
            activity.priceType !== 3 &&
            checkGoodsList.some((item) => {
              return !item.maxQuantity;
            })
          ) {
            this.$message.warning("请填写活动库存");
            return;
          }
          if (
            activity.priceType !== 2 &&
            checkGoodsList.some((item) => {
              return !item.goodsPriceList || !item.goodsPriceList.length;
            })
          ) {
            this.$message.warning("请设置阶梯");
            return;
          }

          if (activity.priceType === 2) {
            if (
              checkGoodsList.some((item) => {
                return !item.singlePrice;
              })
            ) {
              this.$message.warning("请填写拼单价");
              return;
            }
            if (
              checkGoodsList.some((item) => {
                return !item.startQuantity;
              })
            ) {
              this.$message.warning("请填写起订量");
              return;
            }
          }

          if (activity.priceType === 3) {
            if (Number(activity.depositRatio) > 20) {
              this.$message.warning("定金比例不得高于20%");
              return;
            }
            if (
              checkGoodsList.some((item) => {
                return !item.startQuantity;
              })
            ) {
              this.$message.warning("请填写起订量");
              return;
            }
          }

          const goodsInfoList = checkGoodsList.map((item) => {
            const { goodsId, startQuantity, maxQuantity, singlePrice, goodsPriceList, orgMaxQuantity } = item;
            let stockChangeValue = 0;
            if (orgMaxQuantity) {
              stockChangeValue = maxQuantity - orgMaxQuantity;
            }
            let retItem = {
              goodsId,
              startQuantity,
              maxQuantity,
              singlePrice,
              stockChangeValue,
            };
            if (activity.priceType === 1) {
              retItem = {
                goodsId,
                maxQuantity,
                startQuantity: goodsPriceList[0].minQuantity,
                stockChangeValue,
                goodsLadderPriceList: goodsPriceList,
              };
            }

            if (activity.priceType === 3) {
              retItem = {
                goodsId,
                maxQuantity,
                startQuantity,
                stockChangeValue,
                goodsLadderPriceList: goodsPriceList,
              };
            }
            return retItem;
          });
          if (
            goodsInfoList.some((item) => {
              return Number(item.stockChangeValue) < 0;
            })
          ) {
            this.$message.warning("仅支持增加活动库存");
            return;
          }

          this.activity = {
            ...activity,
            goodsInfoList,
            ruleDesc: this.$refs.tinymce.getMain(),
            depositRatio: activity.priceType === 3 ? activity.depositRatio : "",
            paymentTimeLimit: activity.priceType === 3 ? activity.paymentTimeLimit : "",
          };
          console.log("this.activity", this.activity);

          let priceList = [];
          if (activity.priceType === 2) {
            priceList = checkGoodsList.map((item) => {
              const { marketPriceStr, singlePrice } = item;
              const diff = Number(marketPriceStr) - Number(singlePrice);
              return diff;
            });
          } else {
            checkGoodsList.forEach((item) => {
              const { marketPriceStr, goodsPriceList } = item;
              console.log("goodsPriceList", goodsPriceList);
              goodsPriceList.forEach((item1) => {
                const diff = Number(marketPriceStr) - Number(item1.price);
                priceList.push(diff);
              });
            });
          }
          if (
            priceList.some((item) => {
              return item < 0;
            })
          ) {
            this.$confirm("存在活动价高于原价的商品，您确定要发布活动吗？", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
            }).then(() => {
              this.updateApi(this.activity);
            });
            return;
          }
          this.updateApi(this.activity);
        }
      });
    },

    updateApi(arg) {
      this.$store.dispatch("groupBuying/updateCombinationOrder", arg).then((res) => {
        const msg = this.activity.id ? "编辑成功" : "添加成功";
        if (res.code === "0") {
          this.$message.success(msg);
          this.toList();
        } else {
          this.$message.warning(res.msg);
        }
      });
    },

    getDetail() {
      this.$store
        .dispatch("groupBuying/getCombinationOrder", {
          id: this.activityId,
        })
        .then((data) => {
          const activity = data;
          const { startTime, endTime, goodsInfoList, ruleDesc, status, thresholdLimit } = activity;
          this.isEdit = status !== 0 ? true : false;
          this.date = [startTime, endTime];
          // 商品
          this.checkGoodsList = goodsInfoList.map((item) => {
            const { spec, maxQuantity, goodsMainImgUrl, goodsName, originalPrice, goodsLadderPriceList } = item;
            return {
              ...item,
              orgMaxQuantity: maxQuantity,
              name: goodsName,
              picUrl: goodsMainImgUrl,
              marketPriceStr: originalPrice,
              goodsPriceList: goodsLadderPriceList,
              unit: spec.split("/")[1],
            };
          });
          this.activity = {
            ...activity,
            thresholdLimit: thresholdLimit || 0,
          };
          console.log("activity", this.activity);
          // this.areaValue = shippingArea.replace("$", "").split("$");
          this.TinymceMain = ruleDesc;
          this.$refs.tinymce.setMain(ruleDesc);
        });
    },
    toList() {
      this.$refs.tinymce.setMain("");
      this.$router.push("/mj/groupBuying");
    },
    // areaChange(value = []) {
    //   // const areaId = value[value.length - 1];
    //   this.activity = {
    //     ...this.activity,
    //     shippingArea: `$${value.join("$")}`,
    //   };
    // },
    goodPriceSet(index, row) {
      if (row.goodsPriceList) {
        this.goodsPriceList = row.goodsPriceList;
      } else {
        this.goodsPriceList = [];
        const item = {
          level: 1,
          minQuantity: "",
          maxQuantity: "",
          price: "",
        };
        this.goodsPriceList.push(item);
        const item1 = {
          ...item,
          level: 2,
        };
        this.goodsPriceList.push(item1);
      }

      this.priceIndex = index;
      this.goodPriceVisible = true;
    },
    addGoodPrice() {
      if (this.goodsPriceList.length >= 4) {
        this.$message.warning("最多设置四级阶梯");
        return;
      }
      const level = this.goodsPriceList.length + 1;
      const item = {
        level,
        minQuantity: "",
        maxQuantity: "",
        price: "",
      };
      this.goodsPriceList.push(item);
      // this.goodsPriceList.splice(level, 0, item);
      // this.goodsPriceList.forEach((item, index) => {
      //   item.level = index + 1;
      // });
    },
    delGoodPrice(index) {
      this.goodsPriceList.splice(index, 1);
      this.goodsPriceList.forEach((item, index) => {
        item.level = index + 1;
      });
    },
    goodsPriceConfirm() {
      if (
        this.goodsPriceList.some((item) => {
          return !item.minQuantity;
        })
      ) {
        this.$message.warning("请设置阶梯量");
        return;
      }
      if (
        this.goodsPriceList.some((item) => {
          return !item.price;
        })
      ) {
        this.$message.warning("请设置价格");
        return;
      }
      const minQuantityList = [];
      const priceList = [];
      this.goodsPriceList.forEach((item, index) => {
        minQuantityList.push(Number(item.minQuantity));
        priceList.push(Number(item.price));
        if (index + 1 === this.goodsPriceList.length) {
          item.maxQuantity = -1;
        } else {
          item.maxQuantity = this.goodsPriceList[index + 1].minQuantity;
        }
      });
      const isSorted = (nums) => {
        return nums.every((x, i) => i === 0 || x >= nums[i - 1]);
      };
      if (!isSorted(minQuantityList)) {
        this.$message.warning("阶梯量应逐级递增");
        return;
      }
      if (!isSorted(priceList.reverse())) {
        this.$message.warning("价格应逐级递减");
        return;
      }
      const { priceIndex, checkGoodsList } = this;
      this.$set(this.checkGoodsList, priceIndex, {
        ...checkGoodsList[priceIndex],
        goodsPriceList: this.goodsPriceList,
      });
      this.$message.success("设置成功");
      this.goodPriceVisible = false;
    },
    priceTypeChange() {
      this.checkGoodsList = [];
    },
  },
};
